import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

//images
import pic1 from "../../assets/images/project/pic1.jpg";

import avat1 from "../../assets/images/avatar/avatar1.jpg";
import moment from "moment/moment";

const ProjectMasonry = ({ projects, user }) => {
  const [dropbtn, setDropbtn] = useState("Newest");
  // const [popular, setPopular ] = useState([]);
  // const [filtered, setFiltered ] = useState([]);
  const [activeGenre, setActiveGenre] = useState(0);

  // useEffect(()=>{
  //     fetchPopular();
  // },[])
  // function  fetchPopular(){
  //     setPopular(cardData);
  //     setFiltered(cardData);
  // }

  // useEffect(()=>{
  //     if(activeGenre===0){
  //         setFiltered(cardData);
  //         return;
  //     }
  //     const filtered = popular.filter((card)=>
  //      card.cardid.includes(activeGenre)
  //     );
  //     setFiltered(filtered);
  // }, [activeGenre]);
  return (
    <>
      <div className="row m-b30">
        <div className="col-xl-10 col-lg-9">
          <div className="site-filters style-1 clearfix">
            <ul className="filters" data-bs-toggle="buttons">
              <li className={`btn ${activeGenre === 0 ? "active" : ""}`}>
                <Link to={"#"} onClick={() => setActiveGenre(0)}>
                  All Projects
                </Link>
              </li>
              <li
                data-filter=".Technology"
                className={`btn ${activeGenre === 1 ? "active" : ""}`}
              >
                <Link to={"#"} onClick={() => setActiveGenre(1)}>
                  Energy
                </Link>
              </li>
              <li
                data-filter=".Medical"
                className={`btn ${activeGenre === 2 ? "active" : ""}`}
              >
                <Link to={"#"} onClick={() => setActiveGenre(2)}>
                  Education
                </Link>
              </li>
              <li
                data-filter=".Business"
                className={`btn ${activeGenre === 3 ? "active" : ""}`}
              >
                <Link to={"#"} onClick={() => setActiveGenre(3)}>
                  Technology
                </Link>
              </li>
              <li
                data-filter=".Fashion"
                className={`btn ${activeGenre === 4 ? "active" : ""}`}
              >
                <Link to={"#"} onClick={() => setActiveGenre(4)}>
                  Health
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 text-start text-lg-end m-b20">
          <Dropdown className="select-drop">
            <Dropdown.Toggle as="div" className="i-false select-drop-btn">
              <span>{dropbtn}</span>
              <i className="fa-regular fa-angle-down"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setDropbtn("Newest")}>
                Newest
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setDropbtn("Oldest")}>
                Oldest
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <div className="clearfix">
        <ul
          //layout
          id="masonry"
          className="row"
          //transition={{ duration: 0.3 }}
        >
          <AnimatePresence>
            {projects.map((project, index) => {
              return (
                <motion.li
                  layout
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0, opacity: 0 }}
                  transition={{ duration: 0.2 }}
                  className="card-container col-xl-4 col-lg-6 col-md-6 col-sm-12 Fashion m-b30"
                  key={index}
                  //transition={{ duration: 0.5 }}
                >
                  <Link to={`/project-details/${project.id}`}>
                    <div
                      className="dz-card style-2 overlay-skew"
                      style={{ position: "relative" }}
                    >
                      <div
                        style={{
                          backgroundColor: "#E9F2F1",
                          color: "#1A8271",
                          position: "absolute",
                          top: 10,
                          left: 10,
                          zIndex: 9,
                          borderRadius: 5,
                          padding: "5px 15px",
                          fontWeight: "600",
                          fontSize: 14,
                          textTransform: "capitalize",
                        }}
                      >
                        <span>{project.funding_status}</span>
                      </div>
                      <div className="dz-media">
                        <Link to={`/project-details/${project.id}`}>
                          <img
                            src={project.image}
                            style={{ height: 200, objectFit: "cover" }}
                            alt=""
                          />
                        </Link>
                      </div>
                      <div className="dz-info">
                        <ul className="dz-category">
                          <li>
                            <Link to={`/project-details/${project.id}`}>
                              {project.category}
                            </Link>
                          </li>
                        </ul>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                          }}
                        >
                          <h5 className="dz-title">
                            <Link to={`/project-details/${project.id}`}>
                              {project.title}
                            </Link>
                          </h5>
                          <div className="goal">
                            <i className="lar la-clock"></i>
                            <span
                              className="text-primary"
                              style={{ marginLeft: 5 }}
                            >
                              {project.days_left}
                            </span>
                          </div>
                        </div>
                        <div className="progress-bx style-1">
                          <div className="progress">
                            <div
                              className="progress-bar progress-bar-secondary progress-bar-striped progress-bar-animated"
                              style={{ width: project.progress + "%" }}
                            ></div>
                          </div>
                          <ul className="progress-tag">
                            <li className="raised">
                              <i className="las la-coins"></i> Raised:{" "}
                              <span className="text-primary">
                                $ {project.total_pledged}
                              </span>
                            </li>
                            <li className="goal">
                              <i className="las la-coins"></i> Goal:{" "}
                              <span className="text-primary">
                                {project.goal_amount}
                              </span>
                            </li>
                          </ul>
                          <ul className="progress-tag">
                            <li className="raised">
                              <i className="lar la-calendar"></i> Start:{" "}
                              <span className="text-primary">
                                {moment(project.start_date).format(
                                  "DD-MM-YYYY"
                                )}
                              </span>
                            </li>
                            <li className="goal">
                              <i className="lar la-calendar"></i> End:{" "}
                              <span className="text-primary">
                                {moment(project.end_date).format("DD-MM-YYYY")}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Link>
                </motion.li>
              );
            })}
          </AnimatePresence>
        </ul>
      </div>
      <div className="row">
        <div className="col-12 m-sm-t0 m-t30">
          <nav className="pagination-bx">
            <div className="page-item">
              <Link to={"#"} className="page-link prev">
                <i className="fas fa-chevron-left"></i>
              </Link>
            </div>
            <ul className="pagination">
              <li className="page-item">
                <Link to={"#"} className="page-link active">
                  1
                </Link>
              </li>
              <li className="page-item">
                <Link to={"#"} className="page-link">
                  2
                </Link>
              </li>
              <li className="page-item">
                <Link to={"#"} className="page-link">
                  3
                </Link>
              </li>
              <li className="page-item">
                <Link to={"#"} className="page-link">
                  4
                </Link>
              </li>
            </ul>
            <div className="page-item">
              <Link to={"#"} className="page-link next">
                <i className="fas fa-chevron-right"></i>
              </Link>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default ProjectMasonry;
